import { ActiveNetworks } from '~/components/ActiveNetworks'
import { ChangeNetworksDialog } from '~/components/ActiveNetworks/ChangeNetworksDialog'
import {
  useSetupNetworks,
  useUpdateSetupNetworks,
} from '~/components/create-workspace/steps/6_ReviewStep/networks/queries'
import { useActiveOrg } from '~/hooks/org/useActiveOrg'

export const Networks = () => {
  const { networks, isLoading } = useSetupNetworks()

  return (
    <ActiveNetworks
      chainIds={networks ?? []}
      isLoading={isLoading}
      renderDialog={(close) => (
        <SetupNetworksDialog networks={networks ?? []} onClose={close} />
      )}
    />
  )
}

const SetupNetworksDialog = ({
  networks,
  onClose,
}: {
  networks: number[]
  onClose: () => void
}) => {
  const { org } = useActiveOrg()
  const { updateSetupNetworks, isPending } = useUpdateSetupNetworks()

  return (
    <ChangeNetworksDialog
      networks={networks}
      isSaving={isPending}
      canSave={!!org}
      onClose={onClose}
      onSave={(selected) => {
        if (!org) return
        updateSetupNetworks(
          { orgId: org.id, networks: selected },
          { onSuccess: onClose },
        )
      }}
    />
  )
}
